var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g2, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProspects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 472,
    height: 366,
    viewBox: "0 0 472 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_870_1406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.641 185.436C411.482 185.336 411.322 185.246 411.152 185.146C399.663 178.452 386.117 175.874 373.071 172.647C360.943 169.65 347.327 165.623 338.014 156.781C326.695 146.03 328.272 131.214 332.624 117.755C337.196 103.628 341.508 89.3905 339.482 74.3938C337.176 57.2989 329.49 40.7935 317.272 27.9649C298.316 8.0625 268.939 -2.48816 240.8 0.499197C203.038 4.50565 172.024 30.5626 148.476 58.7976C133.024 77.3212 123.911 98.3526 106.282 115.947C88.8639 133.332 69.2892 148.998 54.6357 168.7C35.1209 194.917 25.618 228.358 31.9466 259.87C38.2852 291.382 61.4234 320.136 93.1162 331.516C113.3 338.76 135.44 338.91 157.021 338.97C201.86 339.09 246.749 339.199 291.438 335.802C320.845 333.564 350.651 329.658 377.443 317.968C404.235 306.279 427.962 285.747 436.746 259.09C445.47 232.604 436.397 200.222 411.631 185.446L411.641 185.436Z",
    fill: "#BFD2FF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_870_1406)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_870_1406)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 210,
    width: 303,
    height: 61,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 239.5,
    r: 20.5,
    fill: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 229,
    width: 21,
    height: 7,
    rx: 3,
    fill: "#84BBFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 229,
    width: 57,
    height: 7,
    rx: 3,
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 243,
    width: 115,
    height: 7,
    rx: 3,
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 224,
    width: 81,
    height: 31,
    fill: "#DDEDFF"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_870_1406)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 116,
    width: 345,
    height: 61,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 145.5,
    r: 20.5,
    fill: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 135,
    width: 21,
    height: 7,
    rx: 3,
    fill: "#84BBFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 135,
    width: 57,
    height: 7,
    rx: 3,
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 149,
    width: 115,
    height: 7,
    rx: 3,
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 130,
    width: 79,
    height: 31,
    fill: "#DDEDFF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.335 32.9528L136.558 20.0051C132.94 19.8629 130 22.7097 130 26.3654V319.787C130 323.442 132.94 326.217 136.558 325.987L293.946 315.958C297.183 315.752 299.802 312.792 299.802 309.346V32.6618C299.802 29.2155 295.572 33.0806 292.335 32.9528Z",
    fill: "#DDEDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.479 25.5576C256.479 23.5187 258.103 21.8766 260.08 21.914L261.431 21.8457L267.903 24.3508V26.641L256.479 25.5587V25.5576Z",
    fill: "#DDEDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M298.146 26.1913L140.758 20.0051C137.14 19.8629 134.2 22.7097 134.2 26.3654V319.787C134.2 323.442 137.14 326.217 140.758 325.987L298.146 315.958C301.383 315.752 304.003 312.792 304.003 309.346V32.6618C304.003 29.2155 301.383 26.3191 298.146 26.1913Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.775 241.83C231.101 208.399 251.152 194.571 243.509 164.297C234.056 126.854 197.641 125.206 185.218 88.4101C180.456 74.3041 178.574 52.9881 192.204 22.0275L140.757 20.0051C137.139 19.8629 134.199 22.7097 134.199 26.3654V319.787C134.199 323.442 137.139 326.217 140.757 325.987L281.176 317.04C245.578 288.967 235.418 262.376 233.774 241.83H233.775Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M298.146 29.8756L140.758 23.8955C139.275 23.8393 138.067 25.0108 138.067 26.5086V319.549C138.067 321.046 139.275 322.189 140.758 322.096L298.146 312.274C299.475 312.191 300.555 310.972 300.555 309.557V32.5339C300.555 31.1188 299.475 29.9263 298.146 29.8756Z",
    fill: "url(#paint0_linear_870_1406)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M221.594 159.341C192.128 159.571 167.707 134.686 167.707 103.864C167.707 73.0407 192.127 48.7016 221.594 49.591C250.472 50.4617 273.544 75.332 273.544 105.046C273.544 134.76 250.472 159.115 221.594 159.341Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M270.021 105.008C270.021 132.751 248.542 155.382 221.594 155.557C194.134 155.736 171.488 132.613 171.488 103.907C171.488 75.1998 194.134 52.5833 221.594 53.3757C248.542 54.1527 270.021 77.264 270.021 105.008Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M280.561 178.937L160.116 180.732C156.749 180.783 154.015 183.598 154.015 187.02C154.015 190.442 156.749 193.164 160.116 193.1L280.561 190.8C283.652 190.741 286.152 188.043 286.152 184.774C286.152 181.504 283.652 178.891 280.561 178.937Z",
    fill: "url(#paint1_linear_870_1406)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M280.561 202.294L181.893 204.58C178.577 204.657 175.882 207.473 175.882 210.87C175.882 214.267 178.576 216.947 181.893 216.857L280.561 214.158C283.652 214.073 286.152 211.354 286.152 208.085C286.152 204.815 283.652 202.223 280.561 202.294Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.173 217.451L160.061 217.454C156.726 217.545 154.017 214.966 154.017 211.694V211.151C154.017 207.879 156.726 205.163 160.061 205.086L160.173 205.084C163.5 205.007 166.193 207.587 166.193 210.844V211.386C166.193 214.645 163.501 217.36 160.173 217.451Z",
    fill: "#B19AF3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M160.116 218.611C156.124 218.722 152.868 215.509 152.868 211.45C152.868 207.391 156.124 204.014 160.116 203.924C164.097 203.833 167.329 207.046 167.329 211.085C167.329 215.125 164.098 218.5 160.116 218.611ZM160.116 206.243C157.386 206.307 155.161 208.618 155.161 211.393C155.161 214.168 157.386 216.366 160.116 216.292C162.841 216.218 165.054 213.908 165.054 211.143C165.054 208.377 162.841 206.179 160.116 206.243Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M280.561 223.424L181.893 226.446C178.577 226.548 175.882 229.385 175.882 232.781C175.882 236.178 178.576 238.839 181.893 238.723L280.561 235.288C283.652 235.18 286.152 232.443 286.152 229.173C286.152 225.903 283.652 223.33 280.561 223.424Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M160.173 239.48L160.061 239.485C156.726 239.6 154.017 237.042 154.017 233.77V233.227C154.017 229.955 156.726 227.219 160.061 227.117L160.173 227.113C163.5 227.012 166.193 229.571 166.193 232.83V233.371C166.193 236.63 163.501 239.365 160.173 239.481V239.48Z",
    fill: "#B19AF3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.116 240.641C156.124 240.782 152.868 237.594 152.868 233.535C152.868 229.476 156.124 226.075 160.116 225.954C164.097 225.834 167.329 229.023 167.329 233.062C167.329 237.101 164.098 240.501 160.116 240.641ZM160.116 228.273C157.386 228.358 155.161 230.685 155.161 233.46C155.161 236.235 157.386 238.416 160.116 238.322C162.841 238.229 165.054 235.902 165.054 233.136C165.054 230.37 162.841 228.188 160.116 228.273Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M280.561 244.556L181.893 248.314C178.577 248.441 175.882 251.296 175.882 254.694C175.882 258.091 178.576 260.732 181.893 260.59L280.561 256.418C283.652 256.287 286.152 253.531 286.152 250.261C286.152 246.991 283.652 244.437 280.561 244.555V244.556Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M160.116 262.672C156.124 262.843 152.868 259.679 152.868 255.62C152.868 251.561 156.124 248.135 160.116 247.986C164.097 247.836 167.329 251 167.329 255.039C167.329 259.078 164.098 262.503 160.116 262.672ZM160.116 250.304C157.386 250.409 155.161 252.753 155.161 255.528C155.161 258.304 157.386 260.468 160.116 260.354C162.841 260.239 165.054 257.896 165.054 255.131C165.054 252.365 162.841 250.2 160.116 250.304Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280.561 265.687L181.893 270.183C178.577 270.334 175.882 273.21 175.882 276.608C175.882 280.005 178.576 282.624 181.893 282.46L280.561 277.551C283.652 277.397 286.152 274.623 286.152 271.353C286.152 268.084 283.652 265.547 280.561 265.688V265.687Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.173 283.54L160.061 283.546C156.726 283.712 154.017 281.194 154.017 277.922V277.379C154.017 274.106 156.726 271.33 160.061 271.178L160.173 271.173C163.5 271.02 166.193 273.54 166.193 276.799V277.34C166.193 280.599 163.501 283.374 160.173 283.54Z",
    fill: "#B19AF3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.116 284.703C156.124 284.904 152.868 281.764 152.868 277.705C152.868 273.646 156.124 270.196 160.116 270.015C164.097 269.836 167.329 272.975 167.329 277.015C167.329 281.054 164.098 284.502 160.116 284.702V284.703ZM160.116 272.335C157.386 272.461 155.161 274.82 155.161 277.596C155.161 280.371 157.386 282.519 160.116 282.384C162.841 282.25 165.054 279.89 165.054 277.125C165.054 274.36 162.841 272.211 160.116 272.336V272.335Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_870_1406",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 57,
    width: 92,
    height: 95
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M266.49 104.969C266.49 130.689 246.564 151.644 221.595 151.774C196.188 151.906 175.26 130.495 175.26 103.95C175.26 77.4041 196.187 56.4617 221.595 57.1616C246.564 57.8493 266.49 79.2491 266.49 104.969Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_870_1406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.936 72.4778C232.344 69.7324 237.935 67.7365 242.671 68.1156C255.632 69.1538 269.342 88.54 265.968 101.276C263.011 112.435 248.096 114.22 248.532 123.146C248.864 129.931 257.721 133.392 256.654 135.615C255.533 137.95 244.292 137.182 238.261 129.901C232.565 123.026 233.879 113.205 234.325 109.864C236.199 95.8448 245.095 91.5179 242.671 84.1128C240.449 77.3238 231.397 76.107 231.936 72.4778Z",
    fill: "url(#paint2_linear_870_1406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.489 138.983C171.489 138.983 215.505 112.403 270.022 138.908C270.022 138.908 263.071 161.667 221.595 163.166C178.892 164.709 171.489 138.983 171.489 138.983Z",
    fill: "url(#paint3_linear_870_1406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.787 104.38L212.136 117.073C211.573 121.404 208.685 125.026 204.669 126.43L191.251 131.121C191.251 131.121 216.939 143.906 249.42 131.111L234.607 125.781C230.404 124.147 227.54 120.038 227.357 115.367L226.933 104.529L213.788 104.382L213.787 104.38Z",
    fill: "url(#paint4_linear_870_1406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.521 112.972C208.772 111.102 205.155 105.397 203.011 102.014C199.417 96.3443 194.456 84.609 199.126 77.9401C201.198 74.9798 202.893 76.2792 215.338 70.6826C222.652 67.3928 223.586 66.2565 226.289 66.5872C233.926 67.5229 238.364 78.0789 238.961 79.4974C239.746 81.3621 244.24 92.0505 238.601 102.063C234.08 110.091 224.336 115.414 215.522 112.972H215.521Z",
    fill: "url(#paint5_linear_870_1406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.822 93.3971C233.822 104.115 227.573 115.585 219.826 115.529C212.039 115.471 205.694 103.797 205.694 92.9739C205.694 82.1511 212.039 76.3628 219.826 76.5248C227.572 76.6857 233.822 82.679 233.822 93.3971Z",
    fill: "url(#paint6_linear_870_1406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.226 99.9477C206.568 99.8892 204.631 88.6256 209.83 85.5661C213.283 83.5349 219.276 85.4868 222.647 89.1965C227.961 95.0454 224.987 103.339 229.012 105.155C231.567 106.308 234.979 103.956 236.613 102.227C241.719 96.8232 241.023 85.2609 234.988 78.6636C230.178 73.4054 223.651 73.1233 222.099 73.1056C213.217 73.0042 205.062 79.715 203.194 87.7329C201.757 93.8948 204.232 99.9895 205.224 99.9466L205.226 99.9477Z",
    fill: "url(#paint7_linear_870_1406)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.35
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M233.775 241.83C231.101 208.399 251.152 194.571 243.508 164.297C234.056 126.854 197.64 125.206 185.218 88.4101C180.652 74.886 178.734 54.7327 190.604 25.7889L140.758 23.8955C139.275 23.8393 138.067 25.0108 138.067 26.5086V319.549C138.067 321.046 139.275 322.189 140.758 322.096L276.93 313.598C244.755 286.781 235.349 261.525 233.774 241.83H233.775Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_870_1406)"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M298.146 26.1913L140.758 20.0051C137.14 19.8629 134.2 22.7097 134.2 26.3654V319.787C134.2 323.442 137.14 326.217 140.758 325.987L298.146 315.958C301.383 315.752 304.003 312.792 304.003 309.346V32.6618C304.003 29.2155 301.383 26.3191 298.146 26.1913Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M233.775 241.83C231.101 208.399 251.152 194.571 243.509 164.297C234.056 126.854 197.641 125.206 185.218 88.4101C180.456 74.3041 178.574 52.9881 192.204 22.0275L140.757 20.0051C137.139 19.8629 134.199 22.7097 134.199 26.3654V319.787C134.199 323.442 137.139 326.217 140.757 325.987L281.176 317.04C245.578 288.967 235.418 262.376 233.774 241.83H233.775Z",
    fill: "white"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M298.146 29.8756L140.758 23.8955C139.275 23.8393 138.067 25.0108 138.067 26.5086V319.549C138.067 321.046 139.275 322.189 140.758 322.096L298.146 312.274C299.475 312.191 300.555 310.972 300.555 309.557V32.5339C300.555 31.1188 299.475 29.9263 298.146 29.8756Z",
    fill: "url(#paint8_linear_870_1406)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M221.594 159.341C192.128 159.571 167.707 134.686 167.707 103.864C167.707 73.0407 192.127 48.7016 221.594 49.591C250.472 50.4617 273.544 75.332 273.544 105.046C273.544 134.76 250.472 159.115 221.594 159.341Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M270.021 105.008C270.021 132.751 248.542 155.382 221.594 155.557C194.134 155.736 171.488 132.613 171.488 103.907C171.488 75.1998 194.134 52.5833 221.594 53.3757C248.542 54.1527 270.021 77.264 270.021 105.008Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M280.561 178.937L160.116 180.732C156.749 180.783 154.015 183.598 154.015 187.02C154.015 190.442 156.749 193.164 160.116 193.1L280.561 190.8C283.652 190.741 286.152 188.043 286.152 184.774C286.152 181.504 283.652 178.891 280.561 178.937Z",
    fill: "#83BAFA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M280.561 202.294L181.893 204.58C178.577 204.657 175.882 207.473 175.882 210.87C175.882 214.267 178.576 216.947 181.893 216.857L280.561 214.158C283.652 214.073 286.152 211.354 286.152 208.085C286.152 204.815 283.652 202.223 280.561 202.294Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M160.173 217.451L160.061 217.454C156.726 217.545 154.017 214.966 154.017 211.694V211.151C154.017 207.879 156.726 205.163 160.061 205.086L160.173 205.084C163.5 205.007 166.193 207.587 166.193 210.844V211.386C166.193 214.645 163.501 217.36 160.173 217.451Z",
    fill: "#83BAFA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M160.116 218.611C156.124 218.722 152.868 215.509 152.868 211.45C152.868 207.391 156.124 204.014 160.116 203.924C164.097 203.833 167.329 207.046 167.329 211.085C167.329 215.125 164.098 218.5 160.116 218.611ZM160.116 206.243C157.386 206.307 155.161 208.618 155.161 211.393C155.161 214.168 157.386 216.366 160.116 216.292C162.841 216.218 165.054 213.908 165.054 211.143C165.054 208.377 162.841 206.179 160.116 206.243Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M280.561 223.424L181.893 226.446C178.577 226.548 175.882 229.385 175.882 232.781C175.882 236.178 178.576 238.839 181.893 238.723L280.561 235.288C283.652 235.18 286.152 232.443 286.152 229.173C286.152 225.903 283.652 223.33 280.561 223.424Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M160.173 239.48L160.061 239.485C156.726 239.6 154.017 237.042 154.017 233.77V233.227C154.017 229.955 156.726 227.219 160.061 227.117L160.173 227.113C163.5 227.012 166.193 229.571 166.193 232.83V233.371C166.193 236.63 163.501 239.365 160.173 239.481V239.48Z",
    fill: "#83BAFA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M160.116 240.641C156.124 240.782 152.868 237.594 152.868 233.535C152.868 229.476 156.124 226.075 160.116 225.954C164.097 225.834 167.329 229.023 167.329 233.062C167.329 237.101 164.098 240.501 160.116 240.641ZM160.116 228.273C157.386 228.358 155.161 230.685 155.161 233.46C155.161 236.235 157.386 238.416 160.116 238.322C162.841 238.229 165.054 235.902 165.054 233.136C165.054 230.37 162.841 228.188 160.116 228.273Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M280.561 244.556L181.893 248.314C178.577 248.441 175.882 251.296 175.882 254.694C175.882 258.091 178.576 260.732 181.893 260.59L280.561 256.418C283.652 256.287 286.152 253.531 286.152 250.261C286.152 246.991 283.652 244.437 280.561 244.555V244.556Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M160.116 262.672C156.124 262.843 152.868 259.679 152.868 255.62C152.868 251.561 156.124 248.135 160.116 247.986C164.097 247.836 167.329 251 167.329 255.039C167.329 259.078 164.098 262.503 160.116 262.672ZM160.116 250.304C157.386 250.409 155.161 252.753 155.161 255.528C155.161 258.304 157.386 260.468 160.116 260.354C162.841 260.239 165.054 257.896 165.054 255.131C165.054 252.365 162.841 250.2 160.116 250.304Z",
    fill: "#DDEDFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M280.561 265.687L181.893 270.183C178.577 270.334 175.882 273.21 175.882 276.608C175.882 280.005 178.576 282.624 181.893 282.46L280.561 277.551C283.652 277.397 286.152 274.623 286.152 271.353C286.152 268.084 283.652 265.547 280.561 265.688V265.687Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M160.173 283.54L160.061 283.546C156.726 283.712 154.017 281.194 154.017 277.922V277.379C154.017 274.106 156.726 271.33 160.061 271.178L160.173 271.173C163.5 271.02 166.193 273.54 166.193 276.799V277.34C166.193 280.599 163.501 283.374 160.173 283.54Z",
    fill: "#83BAFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M160.116 284.703C156.124 284.904 152.868 281.764 152.868 277.705C152.868 273.646 156.124 270.196 160.116 270.015C164.097 269.836 167.329 272.975 167.329 277.015C167.329 281.054 164.098 284.502 160.116 284.702V284.703ZM160.116 272.335C157.386 272.461 155.161 274.82 155.161 277.596C155.161 280.371 157.386 282.519 160.116 282.384C162.841 282.25 165.054 279.89 165.054 277.125C165.054 274.36 162.841 272.211 160.116 272.336V272.335Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.35
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M233.775 241.83C231.101 208.399 251.152 194.571 243.508 164.297C234.056 126.854 197.64 125.206 185.218 88.4101C180.652 74.886 178.734 54.7327 190.604 25.7889L140.758 23.8955C139.275 23.8393 138.067 25.0108 138.067 26.5086V319.549C138.067 321.046 139.275 322.189 140.758 322.096L276.93 313.598C244.755 286.781 235.349 261.525 233.774 241.83H233.775Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M291.3 67.1856L276.893 56.1049L262.338 66.51V31.5453C262.338 28.8187 261.072 26.1979 258.905 24.4411L258.793 24.3496L286.262 25.3966C289.046 25.5024 291.299 27.851 291.299 30.6427V67.1866L291.3 67.1856Z",
    fill: "white"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M293.937 67.1856L279.53 55.4569L264.974 66.4704V29.4613C264.974 26.576 263.708 23.8009 261.542 21.9416L261.43 21.8457L288.898 22.9533C291.683 23.0657 293.936 25.5521 293.936 28.5069V67.1878L293.937 67.1856Z",
    fill: "#83BAFA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M275.615 173.548C246.792 174.466 222.888 151.06 222.888 121.354C222.888 91.6471 246.791 67.6464 275.615 67.847C303.84 68.0431 326.376 91.4664 326.376 120.065C326.376 148.664 303.84 172.648 275.615 173.548Z",
    fill: "#83BAFA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M279.248 173.548C250.424 174.466 226.521 151.06 226.521 121.354C226.521 91.6471 250.424 67.6464 279.248 67.847C307.473 68.0431 330.009 91.4664 330.009 120.065C330.009 148.664 307.473 172.648 279.248 173.548Z",
    fill: "#D8DEE8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M326.568 120.108C326.568 146.812 305.587 169.1 279.247 169.903C252.387 170.723 230.222 148.973 230.222 121.309C230.222 93.6444 252.387 71.342 279.247 71.4929C305.586 71.6406 326.568 93.4063 326.568 120.109V120.108Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_870_1406",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 75,
    width: 91,
    height: 92
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M323.12 120.15C323.12 144.907 303.653 165.545 279.247 166.257C254.395 166.982 233.914 146.842 233.914 121.261C233.914 95.6796 254.396 75.0293 279.247 75.1362C303.652 75.2409 323.12 95.3931 323.12 120.15Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_870_1406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.222 155.236C230.222 155.236 273.291 128.602 326.568 152.857C326.568 152.857 319.78 174.927 279.247 177.352C237.47 179.852 230.222 155.236 230.222 155.236Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.614 120.793L269.999 133.057C269.531 140.853 261.965 143.937 261.965 143.937C270.848 154.477 287.827 153.675 293.765 143.369C289.662 141.898 285.061 135.555 284.882 131.061L284.466 120.633L271.612 120.793H271.614Z",
    fill: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.202 109.757C291.202 120.079 285.094 131.267 277.52 131.392C269.904 131.516 263.698 120.417 263.698 109.991C263.698 99.5649 269.904 93.8461 277.52 93.8262C285.094 93.8064 291.202 99.436 291.202 109.757Z",
    fill: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.288 112.625C264.049 112.496 264.811 112.366 265.572 112.237C265.223 111.386 263.78 107.62 265.572 104.301C267.292 101.115 271.34 99.5471 274.431 99.741C277.941 99.9615 280.048 101.597 281.81 100.313C282.799 99.5912 283.12 98.2874 283.233 97.2734C283.312 97.9215 283.489 98.8803 283.944 99.9394C285.254 102.979 287.47 103.601 288.675 105.607C289.487 106.958 290.016 109.224 288.675 113.234C289.344 113.188 290.013 113.141 290.682 113.093C291.387 110.843 292.233 107.651 292.76 103.751C293.541 97.96 294.079 93.9737 291.861 92.0395C291.419 91.6537 289.463 90.1262 284.784 91.5755C283.687 90.4161 281.376 88.2923 277.82 87.2232C276.589 86.8529 270.486 85.019 265.074 88.9976C261.393 91.7033 258.506 96.7488 259.434 100.914C259.924 103.116 261.266 104.099 262.446 108.355C262.944 110.152 263.174 111.665 263.289 112.626L263.288 112.625Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.3 113.584C289.3 113.584 290.178 109.054 292.846 109.479C295.508 109.905 291.693 117.347 289.3 118.265V113.583V113.584Z",
    fill: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.411 113.819C265.411 113.819 264.517 109.264 261.794 109.739C259.066 110.215 262.973 117.671 265.411 118.543V113.819Z",
    fill: "#DDEDFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_870_1406",
    x: -13,
    y: 210,
    width: 343,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_870_1406"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_870_1406"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_870_1406"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_870_1406",
    result: "effect2_dropShadow_870_1406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_870_1406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_870_1406",
    x: 119,
    y: 116,
    width: 385,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_870_1406"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_870_1406"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_870_1406"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_870_1406",
    result: "effect2_dropShadow_870_1406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_870_1406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_870_1406",
    x: 114.199,
    y: 20,
    width: 209.804,
    height: 346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_870_1406"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_870_1406"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_870_1406"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_870_1406",
    result: "effect2_dropShadow_870_1406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_870_1406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_870_1406",
    x1: 297.968,
    y1: 39.3053,
    x2: 179.731,
    y2: 232.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_870_1406",
    x1: 154.015,
    y1: 186.019,
    x2: 286.152,
    y2: 186.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_870_1406",
    x1: 259.095,
    y1: 64.5998,
    x2: 244.513,
    y2: 103.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_870_1406",
    x1: 227.792,
    y1: 106.49,
    x2: 217.624,
    y2: 153.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_870_1406",
    x1: 220.219,
    y1: 108.701,
    x2: 220.413,
    y2: 146.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_870_1406",
    x1: 252.857,
    y1: 25.5389,
    x2: 184.301,
    y2: 155.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_870_1406",
    x1: 225.563,
    y1: 54.1816,
    x2: 216.866,
    y2: 112.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_870_1406",
    x1: 246.399,
    y1: 44.6214,
    x2: 197.253,
    y2: 137.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_870_1406",
    x1: 297.968,
    y1: 39.3053,
    x2: 179.731,
    y2: 232.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_870_1406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472,
    height: 339,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_870_1406"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 210,
    width: 303,
    height: 61,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspects);
export default __webpack_public_path__ + "static/media/Prospects.28a0999b2161bced0cc3267395822d6b.svg";
export { ForwardRef as ReactComponent };